module.exports = __webpack_public_path__ + "img/Topup-2.2ed64df5.svg";